

















module.exports =
  name: 'transaction_current_popover_destroy_button'
  components:
    updated_accounts: require('./updated_accounts.vue').default
  props: ['transaction']
  data: ->
    dialogVisible: false
    loading: false
  watch:
    transaction: -> @dialogVisible = false
  methods:
    close: -> @dialogVisible = false
    dispatchEvent: (destroy_future_trs) ->
      @dialogVisible = false
      opts = { transaction: @transaction, destroy_future_trs: destroy_future_trs }
      @loading = true
      @$store.dispatch('destroyTransaction', opts).then (res) =>
        HM.track 'transaction-destroy', { subtype: @transaction.subtype }
        @loading = false
        @$emit 'hide'
        if HM.store.state.ui.accounts_virtuals_changed_tooltip.length > 0
          @$notify
            message: @$createElement('updated_accounts')
            duration: 3000
    destroy: ->
      if @transaction.planned_repeat_days > 0
        @dialogVisible = true
      else
        @dispatchEvent(false)
